function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import classnames from 'classnames';
import React, { Component, Fragment } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import Loading from 'swag-client-common/components/info/loading';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import HowManyInEachBox from 'swag-client-common/components/partials/cart/how-many-in-each-box';
import ItemTitle from 'swag-client-common/components/partials/item-title';
import SetupFeeTooltip from 'swag-client-common/components/partials/setupfee-tooltip';
import Image from 'swag-client-common/components/ui/image';
import { notAllowedEditInDraftTooltip, Placement, SUPER_SPEED_ADDON_WARN_TEXT } from 'swag-client-common/constants';
import { Price } from 'swag-client-common/utils/price';
import { removeSuperSpeedProductIdFromLS, setSuperSpeedProductIdInLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import { CART } from 'swag-common/constants/item-sources';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { SPECIAL_PRODUCT_TYPES, SUPER_SPEED_PRODUCTION_OPTION } from 'swag-common/constants/product.constants';
import { getItemNameLabel } from 'swag-common/utils/order/indicators-names.util';
import { isBox } from 'swag-common/utils/order/item-is-box.util';
import BoxControlButtons from '../box-control-buttons';
import { DesktopItemControl } from '../desktop-item-control';
import { ErrorMessage } from '../error-message';
import Quantity from '../quantity';
import ViewColorsTooltip from '../view-colors-tooltip';
import { ProductionTime } from '../production-time';
import classes from './cart-item.scss';
const tooltipTextByBoxType = {
  [SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX]: 'After you place your box order, we will figure out the perfect box size for the products that you selected. We will then send you the box template so that your team can design it. If you need any help with your design we can pitch in!',
  [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX]: 'After you place your box order, we will figure out the perfect box size for the products that you selected. We will then send you a production mockup to approve before boxes are printed.',
  [SPECIAL_PRODUCT_TYPES.COLORED_BOX]: 'After you place your box order, we will figure out the perfect box size for the products that you selected.',
  [SPECIAL_PRODUCT_TYPES.BROWN_BOX]: 'After you place your box order, we will figure out the perfect box size for the products that you selected.'
};
const tooltipStyles = {
  popper: classes.tooltipPopper,
  tooltip: classes.tooltipRoot
};
const loadingStyle = {
  position: 'absolute'
};
export class OrderItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isProdTimeChanged: false
    });
    _defineProperty(this, "setProdTime", (prodTime, embellishmentIndex) => {
      const {
        item,
        onProductionTimeChange
      } = this.props;
      onProductionTimeChange(prodTime, embellishmentIndex, item);
      this.setState({
        isProdTimeChanged: true
      });
    });
    _defineProperty(this, "handleOnProductionTimeClick", e => {
      const {
        item,
        onProductionTimeClick
      } = this.props;
      e.preventDefault();
      return onProductionTimeClick(item);
    });
    _defineProperty(this, "handleOnClickMockup", e => {
      const {
        item,
        onClickMockup
      } = this.props;
      e.preventDefault();
      return onClickMockup(item);
    });
    _defineProperty(this, "handleOnSizeClick", e => {
      const {
        item: {
          _id
        },
        onSizeClick
      } = this.props;
      e.preventDefault();
      return onSizeClick(_id);
    });
    _defineProperty(this, "handleOnQuantityClick", e => {
      const {
        item: {
          _id,
          boxItemsId
        },
        isSavedForLater,
        onQuantityClick,
        onEditQuantityClick
      } = this.props;
      e.preventDefault();
      if (boxItemsId && !isSavedForLater) {
        return onEditQuantityClick(_id);
      }
      return onQuantityClick(_id);
    });
    _defineProperty(this, "handleOnEditRequest", e => {
      var _item$prod, _item$prod$productSet, _item$prod$productSet2, _item$prod$productSet3, _item$prod$productSet4;
      const {
        item,
        onEditRequest
      } = this.props;
      e.preventDefault();
      const isSuperSpeed = ((_item$prod = item.prod) === null || _item$prod === void 0 ? void 0 : (_item$prod$productSet = _item$prod.productSettings) === null || _item$prod$productSet === void 0 ? void 0 : (_item$prod$productSet2 = _item$prod$productSet[0]) === null || _item$prod$productSet2 === void 0 ? void 0 : (_item$prod$productSet3 = _item$prod$productSet2.productionTimeList) === null || _item$prod$productSet3 === void 0 ? void 0 : (_item$prod$productSet4 = _item$prod$productSet3[item.prodTime]) === null || _item$prod$productSet4 === void 0 ? void 0 : _item$prod$productSet4.name) === SUPER_SPEED_PRODUCTION_OPTION;
      if (isSuperSpeed) {
        var _item$prod2;
        setSuperSpeedProductIdInLS((_item$prod2 = item.prod) === null || _item$prod2 === void 0 ? void 0 : _item$prod2._id);
      } else {
        removeSuperSpeedProductIdFromLS();
      }
      return onEditRequest(item);
    });
    _defineProperty(this, "handleOnMoveToDraft", e => {
      const {
        item: {
          _id
        },
        moveToDraft,
        isSuperSpeed
      } = this.props;
      e.preventDefault();
      return moveToDraft(_id, isSuperSpeed);
    });
    _defineProperty(this, "handleOnMoveToCart", e => {
      const {
        item: {
          _id
        },
        moveToCart,
        isSuperSpeed
      } = this.props;
      e.preventDefault();
      return moveToCart(_id, isSuperSpeed);
    });
    _defineProperty(this, "handleOnShareClick", e => {
      const {
        item,
        onShareClick
      } = this.props;
      e.preventDefault();
      return onShareClick(item);
    });
    _defineProperty(this, "handleRemoveItem", e => {
      const {
        item,
        isSavedForLater,
        onOpenRemoveDialog
      } = this.props;
      const storageType = isSavedForLater ? OrderStorageTypes.DRAFT : OrderStorageTypes.CART;
      e.preventDefault();
      return onOpenRemoveDialog(item._id, storageType);
    });
    _defineProperty(this, "getDataAttribute", () => {
      const {
        isItemBoxSpecialNotecard,
        isItemBoxSpecialCrinklePaper,
        isItemBoxSpecialTape
      } = this.props;
      if (isItemBoxSpecialNotecard) {
        return 'Notecard';
      }
      if (isItemBoxSpecialCrinklePaper) {
        return 'Paper';
      }
      if (isItemBoxSpecialTape) {
        return 'Tape';
      }
      return '';
    });
    _defineProperty(this, "onEditBoxName", () => {
      const {
        item: {
          _id
        },
        onEditBoxNameClick
      } = this.props;
      onEditBoxNameClick(_id);
    });
    _defineProperty(this, "handleOpenCommentItemPopup", () => {
      const {
        item: {
          _id
        },
        openCommentItemPopup
      } = this.props;
      openCommentItemPopup(_id);
    });
  }
  componentDidMount() {
    const {
      isProdTimeInvalid
    } = this.props;
    const {
      isProdTimeChanged
    } = this.state;
    if (isProdTimeInvalid && !isProdTimeChanged) {
      this.setProdTime(0, 0);
    }
  }
  render() {
    const {
      item,
      item: {
        quantity,
        price,
        sizeInd,
        prod,
        prodTime,
        isSample,
        isPrintedSample,
        sampleDeductionDiscount,
        setupFee,
        oldSetupFee,
        _id,
        source,
        isCustomizedBlank,
        modifiedProductName,
        pricePerItem
      },
      isSavedForLater,
      isSizeEditable,
      itemLogoSrc,
      isFullDesign,
      isRelatedItem,
      isBoxItem,
      isOrderMore,
      productionTimeList,
      isEditPossible,
      isLoading,
      selectedItem,
      boxValidations,
      isThisItemBox = false,
      isSetupFeeShown,
      isItemBoxSpecialCrinklePaper,
      isItemBoxSpecialNotecard,
      isViewColorsShown,
      isInfoTooltipShown,
      isSetupFeeTooltipShown,
      isSwagSampleBox,
      isProdTimeInvalid,
      isForbiddenToChangeQuantityPerBox,
      validationError,
      isOutOfStock,
      isSampleOutOfStock,
      isBoxItself,
      isEditNameAvailable,
      productName,
      isSharedOrRelatedItem,
      setupFeeLabel,
      isInRelatedItemsList,
      isItemBoxSpecialTape,
      isLimitedEdition,
      isSuperSpeed,
      isSelectingProductionTimeDisabled,
      shouldShowProductionTimeTooltip,
      isProductionTimeClickable,
      isWholeBoxSuperSpeed,
      isSuperSpeedAddonWarn,
      isPlainCard = false,
      showLeaveComment
    } = this.props;
    const {
      assemblyFee,
      specialProductType = '',
      productSettings = []
    } = prod || {};
    const {
      isProdTimeChanged
    } = this.state;
    if (!productionTimeList[prodTime] || isProdTimeInvalid && !isProdTimeChanged) {
      return null;
    }
    const {
      name,
      time
    } = productSettings[0].productionTimeList[prodTime];
    const isBoxItemInDraft = isBoxItem && isSavedForLater;
    const isQuantityClickable = !isSwagSampleBox && !isItemBoxSpecialNotecard && !isOutOfStock && !isBoxItemInDraft && !(validationError !== null && validationError !== void 0 && validationError.isLEOOS);
    const isHowManyInEachBoxClickable = !isForbiddenToChangeQuantityPerBox && !isOutOfStock && !isBoxItemInDraft;
    const shouldShowProductionTimeField = !(isSample || isPrintedSample || isBoxItem);
    return /*#__PURE__*/React.createElement("div", {
      id: _id,
      "data-specialtype": this.getDataAttribute(),
      className: classnames(classes.orderItemWrapper, {
        [classes.relatedOrderItem]: isRelatedItem || isBoxItem,
        [classes.isPlainCard]: isPlainCard
      })
    }, isLoading && !isRelatedItem && !isBoxItem && selectedItem === _id && /*#__PURE__*/React.createElement(Loading, {
      className: classes.loading,
      style: loadingStyle
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.orderItem, {
        [classes.sampleDeductionPromo]: Boolean(sampleDeductionDiscount),
        [classes.isPlainCard]: isPlainCard
      })
    }, /*#__PURE__*/React.createElement("section", {
      className: classnames(classes.section, classes.flexLeft)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.logoAndDescription
    }, /*#__PURE__*/React.createElement(Image, {
      isLE: isLimitedEdition,
      isSuperSpeed: !isWholeBoxSuperSpeed && isSuperSpeed,
      LEClassName: classes.LEClassName,
      superSpeedClassName: classes.superSpeedLabel,
      wrapperClassName: classes.imageWrapper,
      className: classes.prodLogo,
      alt: "customer's mockup",
      src: itemLogoSrc,
      onClick: this.handleOnClickMockup
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.description
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.wrapperForInfo)
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.prodNameWrapper, {
        [classes.notAllowed]: !isEditPossible,
        [classes.widthWithTooltip]: isInfoTooltipShown
      }),
      onClick: this.handleOnEditRequest
    }, /*#__PURE__*/React.createElement(ItemTitle, {
      nameLabel: !isInRelatedItemsList ? getItemNameLabel(Boolean(isRelatedItem)) : '',
      productName: productName,
      modifiedProductName: modifiedProductName
    }), prod && !isSwagSampleBox && /*#__PURE__*/React.createElement(Fragment, null, isSample && /*#__PURE__*/React.createElement("div", {
      className: classes.secondaryText
    }, "blank sample"), isPrintedSample && /*#__PURE__*/React.createElement("div", {
      className: classes.secondaryText
    }, isBoxItself ? 'full box sample' : 'printed sample'))), isEditNameAvailable && /*#__PURE__*/React.createElement(EditIcon, {
      className: classes.editNameIcon,
      onClick: this.onEditBoxName
    }), isInfoTooltipShown && /*#__PURE__*/React.createElement(Tooltip, {
      title: isSuperSpeedAddonWarn ? SUPER_SPEED_ADDON_WARN_TEXT : tooltipTextByBoxType[specialProductType],
      placement: Placement.RIGHT,
      mode: "light",
      className: classes.infoWrapper,
      classes: tooltipStyles,
      interactive: true
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      className: classes.infoButton
    }))), (isSample || isPrintedSample) && !isSwagSampleBox ? /*#__PURE__*/React.createElement(React.Fragment, null, isSizeEditable && /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.quantitySizeSection, classes.clickable, {
        [classes.disabled]: isSampleOutOfStock,
        [classes.hidden]: isItemBoxSpecialCrinklePaper || isItemBoxSpecialTape
      }),
      onClick: this.handleOnSizeClick
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.secondaryTitle
    }, "Size:"), /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.prodPricePink, {
        [classes.greyedOut]: isSampleOutOfStock
      }),
      "data-button": "SampleSize"
    }, prod !== null && prod !== void 0 && prod.size ? prod.size.options[sizeInd] : 'Set')), /*#__PURE__*/React.createElement(ErrorMessage, {
      className: classes.errorMessageFor768AndHigher,
      error: validationError
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.boxSection, {
        [classes.hidden]: isItemBoxSpecialCrinklePaper || isItemBoxSpecialTape
      })
    }, isBoxItem && !isThisItemBox && /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.clickable]: isHowManyInEachBoxClickable
      }),
      onClick: isHowManyInEachBoxClickable ? this.handleOnQuantityClick : undefined
    }, /*#__PURE__*/React.createElement(HowManyInEachBox, {
      quantityPerBox: item.quantityPerBox,
      message: boxValidations[_id],
      tooltipText: notAllowedEditInDraftTooltip,
      isBoxItemInDraft: isBoxItemInDraft,
      isGreyedOut: isForbiddenToChangeQuantityPerBox || isOutOfStock || isBoxItemInDraft
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.quantityWrapper
    }, /*#__PURE__*/React.createElement(Quantity, {
      isBoxItemInDraft: isBoxItemInDraft,
      isLERestricted: !!(validationError !== null && validationError !== void 0 && validationError.isLEOOS),
      isItemBoxSpecialNotecard: isItemBoxSpecialNotecard,
      isQuantityClickable: isQuantityClickable,
      isSwagSampleBox: isSwagSampleBox,
      isOutOfStock: isOutOfStock,
      tooltipText: notAllowedEditInDraftTooltip,
      quantity: quantity,
      handleOnQuantityClick: this.handleOnQuantityClick
    }), /*#__PURE__*/React.createElement(ViewColorsTooltip, {
      className: classes.viewColorsTooltip,
      isShown: Boolean(isViewColorsShown),
      item: item,
      onClick: isQuantityClickable ? this.handleOnQuantityClick : undefined,
      disableTouchListener: true
    }, prod !== null && prod !== void 0 && prod.size ? 'See size breakdown' : 'See colors')), isSwagSampleBox && /*#__PURE__*/React.createElement("span", {
      className: classes.sampleBoxInfo
    }, /*#__PURE__*/React.createElement("br", null), source === CART ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "This sample box includes SWAG.COM branded products. It doesn\u2019t include products that you\u2019ve selected.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Our pre-existing sample box to give you an idea of what yours may look like.")))), isBox(item) && /*#__PURE__*/React.createElement(BoxControlButtons, {
      isSavedForLater: isSavedForLater,
      tooltipText: notAllowedEditInDraftTooltip,
      boxId: item._id,
      className: classes.boxEditButtonsFor768AndHigher
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      className: classes.errorMessageFor768AndHigher,
      error: validationError
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.hr
    })), isSample || isPrintedSample || isBoxItem ? null : /*#__PURE__*/React.createElement(ProductionTime, {
      isProductionTimeClickable: isProductionTimeClickable,
      isSelectingProductionTimeDisabled: isSelectingProductionTimeDisabled,
      handleOnProductionTimeClick: this.handleOnProductionTimeClick,
      time: time,
      shouldShowProductionTimeTooltip: shouldShowProductionTimeTooltip,
      name: name,
      className: classes.productionTimeForTabletAndHigher
    }), showLeaveComment && /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.leaveComment, {
        [classes.biggerMargin]: isItemBoxSpecialCrinklePaper || isItemBoxSpecialTape
      }),
      onClick: this.handleOpenCommentItemPopup
    }, "Leave a comment")))), /*#__PURE__*/React.createElement(ErrorMessage, {
      className: classes.errorMessageFor768AndLower,
      error: validationError
    }), isBox(item) && /*#__PURE__*/React.createElement(BoxControlButtons, {
      isSavedForLater: isSavedForLater,
      tooltipText: notAllowedEditInDraftTooltip,
      boxId: item._id,
      className: classes.boxEditButtonsFor768AndLower
    }), /*#__PURE__*/React.createElement("section", {
      className: classnames(classes.section, classes.flexRight)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.details
    }, /*#__PURE__*/React.createElement("article", {
      className: classnames(classes.pricesSection, {
        [classes.vertCentered]: isSample,
        [classes.pricesSectionWithoutProductionField]: !shouldShowProductionTimeField,
        [classes.priceSectionCrinklePaper]: isItemBoxSpecialCrinklePaper
      })
    }, shouldShowProductionTimeField ? /*#__PURE__*/React.createElement(ProductionTime, {
      isProductionTimeClickable: isProductionTimeClickable,
      isSelectingProductionTimeDisabled: isSelectingProductionTimeDisabled,
      handleOnProductionTimeClick: this.handleOnProductionTimeClick,
      time: time,
      shouldShowProductionTimeTooltip: shouldShowProductionTimeTooltip,
      name: name,
      className: classes.productionTimeForTableAndLower
    }) : null, (isSwagSampleBox || !isSample && !isPrintedSample) && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.priceContainer, classes.itemPriceContainer)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.secondaryTitle, classes.priceTitle)
    }, "Item Price:"), /*#__PURE__*/React.createElement("h5", {
      className: classes.prodPriceBlack,
      "data-text": "ItemPrice"
    }, Price.formatPrice(pricePerItem))), isSetupFeeShown && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.priceContainer, classes.setupFeeContainer)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.secondaryTitle, classes.priceTitle)
    }, setupFeeLabel), Boolean(oldSetupFee) && /*#__PURE__*/React.createElement("h5", {
      className: classes.oldSetupFee,
      "data-text": "OldSetupFee"
    }, Price.formatPrice(oldSetupFee)), /*#__PURE__*/React.createElement("h5", {
      className: classnames(classes.setupFee, {
        [classes.stickyRight]: isSetupFeeTooltipShown
      }),
      "data-text": "SetupFee"
    }, Price.formatPrice(setupFee)), isSetupFeeTooltipShown && /*#__PURE__*/React.createElement(SetupFeeTooltip, {
      isSharedOrRelatedItem: isSharedOrRelatedItem,
      isBoxItem: isBoxItem,
      infoWrapperClassName: classes.setupFeeInfoWrapper
    })), isThisItemBox && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.priceContainer, classes.assemblyFee)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.secondaryTitle, classes.priceTitle)
    }, "Kitting Fee:"), /*#__PURE__*/React.createElement("h5", {
      className: classnames(classes.prodPriceBlack, {
        [classes.stickyRight]: isSetupFeeTooltipShown
      }),
      "data-text": "AssemblyFee"
    }, Price.formatPrice(assemblyFee))), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.priceContainer, classes.totalContainer)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.secondaryTitle, classes.priceTitle)
    }, isBoxItem ? 'Item Total:' : 'Total:'), /*#__PURE__*/React.createElement("h5", {
      className: classes.prodPriceTotal,
      "data-text": "ProductTotalPrice"
    }, Price.formatPrice(price)))))), /*#__PURE__*/React.createElement(DesktopItemControl, {
      isBox: isBox(item),
      isBoxCrinklePaper: isItemBoxSpecialCrinklePaper,
      isBoxTape: isItemBoxSpecialTape,
      isOrderMore: isOrderMore,
      isSample: isSample,
      isBoxItem: isBoxItem,
      isRelatedItem: Boolean(isRelatedItem),
      isEditPossible: isEditPossible,
      isSavedForLater: isSavedForLater,
      isFullDesignMode: isFullDesign,
      isCustomizedBlank: isCustomizedBlank,
      onRemoveClick: this.handleRemoveItem,
      onShareClick: this.handleOnShareClick,
      onEditClick: this.handleOnEditRequest,
      onMoveToCartClick: this.handleOnMoveToCart,
      onMoveToDraftClick: this.handleOnMoveToDraft
    })));
  }
}